import React from "react";

import Grid from "@material-ui/core/Grid";

import useStyles from "./styles";

const RiskProfileCategoryCard = ({category}) => {
  const classes = useStyles();

  return (
    <>
      <Grid item xs={12} className={classes.riskProfileCardTitle}>ERGEBNIS</Grid>
      <Grid item xs={12} className={classes.riskInfoBox}>
        <Grid container alignItems={"center"}>
          <Grid item xs={12} className={'category'}>{category}</Grid>
          <Grid item xs={12}>Risikoprofil / Anlagestrategie</Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default RiskProfileCategoryCard;